import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { expenseStartLoading } from "../../../../../../actions/accounting/expense";
import { incomesStartLoading } from "../../../../../../actions/accounting/incomes";
import {
  downloadSatStartLoading,
  downloadSatStartLoadingAsync,
  getRequestByPeriod,
  sesionSat,
} from "../../../../../../actions/accounting/periods";
import {
  preAutorizedReportRegisterMonthPrevStart,
  preAutorizedReportRegisterStart,
  preAutorizedReportUpdateStart,
} from "../../../../../../actions/accounting/preAuthorizedReports";
import { retentionStartLoading } from "../../../../../../actions/accounting/retentions";
import { taxpayerSelectedLoading } from "../../../../../../actions/taxpayers";
import { initialoptionIsrHonorarium } from "../../../../../../helpers/accounting/obtainIsrHonorariumPorcentage";
import { initialOptionIsrPlataform } from "../../../../../../helpers/accounting/obtainIsrPlataformPorcentaje";
import { initialoptionIsrSimplified } from "../../../../../../helpers/accounting/obtainIsrSimplifiedPorcentage";
import { obtainMonth } from "../../../../../../helpers/declarationPeriod";
import { initialoptionIsr } from "../../../../../../helpers/obtainIsrPorcentage";
import { initialOptionLease } from "../../../../../../helpers/obtainLeasePorcentage";
import { useForm } from "../../../../../../hooks/useForm";
import { UseSwal } from "../../../../../../hooks/UseSwal";
import { ACCOUNTING } from "../../../../../constants/Routes";
import { ModalContext } from "../../../../../modal/ModalContext";
import { StatisticsTable } from "../../../../../XmlDownloads/statistics";
import { CertificateDetailsScreen } from "../../../taxFiles/CertificateDetailsScreen";
import { ComplianceOpinionDetailsScreen } from "../../../taxFiles/ComplianceOpinionDetailsScreen";
import { EfirmaDetailsScreen } from "../../../taxFiles/EfirmaDetailsScreen";
import { CaptchaForm2 } from "./CaptchaFrom2";
import { HonorariumInformation } from "./informationReport/HonorariumInformation";
import { LeaseInformation } from "./informationReport/LeaseInformation";
import { PlataformInformation } from "./informationReport/PlataformInformation";
import { RifInformation } from "./informationReport/RifInformation";
import { SimplifiedInformation } from "./informationReport/SimplifiedInformation";
import { TaxpayerInformation } from "./informationReport/TaxpayerInformation";
import { CommentsScreen } from "./options/comments/CommentsScreen";
import { Complement } from "./options/complement/expense/Complement";
import { ComplementIncome } from "./options/complement/income/ComplementIncome";
import Expenses from "./options/expenses/expenses";
import { FilesScreen } from "./options/files/FilesScreen";
import Income from "./options/income/income";
import Retention from "./options/retention/retention";
import TaxCalculation from "./options/taxCalculation/taxCalculation";

export const DetailsSummary_v2 = () => {
  // console.log("DetailSummaryJS")
  const { month, taxpayerId, regimeSatCode, year, isAdmin } = useParams();
  const { navigationPage } = UseSwal();
  const { authorizations, finishPackage, taxpayerFinishPackage } = useSelector(
    (state) => state.authorizationReport
  );
  // console.log(authorizations)
  const { expenses, finishExpenses } = useSelector((state) => state.expense);
  const { incomes, finishIncomes } = useSelector((state) => state.income);
  const { periodSelected, sesionRetentionSat } = useSelector(
    (state) => state.downloadXMLRequest
  );
  const { retentions, finishRetentions } = useSelector(
    (state) => state.retention
  );
  const { complements } = useSelector((state) => state.complement);
  const { taxpayerSelected } = useSelector((state) => state.taxpayer);
  const { isBoss, userName } = useSelector((state) => state.auth.user);

  const [dataTaxPayer, setData] = useState([]);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showComponent, setShowComponent] = useState(false);
  let history = useHistory();

  const { handleModal } = useContext(ModalContext);

  const {
    commentJson,
    isrJson,
    ivaJson,
    resume,
    id,
    period,
    taxDocuments,
    status,
  } = authorizations;
  const { datos, setDatos } = useForm({
    regimenId: "",
    activityId: "",
  });

  const [periodLoaded, setPeriodLoaded] = useState(false);
  const [informationToLoaded, setInformationToLoaded] = useState(false);
  const [expensesLoaded, setExpensesLoaded] = useState(false);
  const [incomesLoaded, setIncomesLoaded] = useState(false);
  const [retentionsLoaded, setRetentionsLoaded] = useState(false);
  const [loadAll, setLoadAll] = useState(false);
  const { formValues, setFormValues } = useForm({
    comments: null,
    comment: "",
    informationDiots: [],
    depresiations: [],
    reportId: 0,

    subtotalExpenseAutorized: 0.0,
    subtotalExpenseNotAutorized: 0.0,
    subtotalExpensePersonalAutorized: 0.0,
    totalExpenseAutorized: 0.0,
    totalExpenseNotAutorized: 0.0,
    totalExpensePersonalAutorized: 0.0,
    totalIVAExpenseAutorized: 0.0,
    subtotalPredialAutorized: 0.0,

    subtotalExpenseRate0: 0.0,
    totalExpenseRate0: 0.0,
    subtotalExpenseRate8: 0.0,
    totalExpenseRate8: 0.0,
    subtotalExpenseRate16: 0.0,
    totalExpenseRate16: 0.0,

    subtotalIncomesAutorized: 0.0,
    totalIncomesAutorized: 0.0,
    totalIncomesNotAutorized: 0.0,

    subtotalIncomesGeneralPublic: 0.0,
    totalIncomesGeneralPublic: 0.0,
    subtotalIncomesRate16: 0.0,
    totalIncomesRate16: 0.0,
    subtotalIncomesRate0: 0.0,
    totalIncomesRate0: 0.0,

    totalTaxesRate16: 0.0,

    subtotalSumRateExento: 0.0,

    totalISRIncomeAutorized: 0.0,
    totalIVARetainedIncomeAutorized: 0.0,

    totalIvaTraslatedExpense16: 0.0,
    totalIvaTraslatedExpense8: 0.0,

    expenseTotalTaxeTras: 0.0,

    month: month,
    monthName: "",
    isBlindDeduction: false,

    regimeSatCode: regimeSatCode,

    taxISRHonorarium: {
      expensesAccumulateds: 0.0,
      expensesAccumulatedsTotal: 0.0,
      expensesSubtotalAutorized: 0.0,

      incomesAccumulateds: 0.0,
      incomesAccumulatedsTotal: 0.0,
      incomesSubtotalAutorized: 0.0,

      depresiationFixedAsset: 0.0,
      depresiationAcumulated: 0.0,
      depresiations: [],

      nameMonth: "",
      totalISRIncomeAutorized: 0.0,
      retentionPrevMonths: 0.0,
      retentionPaidPrev: 0.0,

      taxableBase: 0.0,
      ISR: initialoptionIsrHonorarium,
    },
    taxIVAHonorarium: {
      subtotalIncome16: 0.0,
      subtotalIncome0: 0.0,
      subtotalIncomeExento: 0.0,
      totalIvaCreditable: 0.0,
      totalIvaRetained: 0.0,
      totalTaxe16: 0.0,
      IVAMonthsPrev: 0.0,
      subtotalIVA: 0.0,
      totalIVA: 0.0,
    },
    taxIVASimplified: {
      subtotalIncome16: 0.0,
      subtotalIncome0: 0.0,
      subtotalIncomeExento: 0.0,
      totalIvaCreditable: 0.0,
      totalIvaRetained: 0.0,
      totalTaxe16: 0.0,
      IVAMonthsPrev: 0.0,
      subtotalIVA: 0.0,
      totalIVA: 0.0,
    },
    taxISRSimplified: {
      expensesAccumulateds: 0.0,
      expensesAccumulatedsTotal: 0.0,
      expensesSubtotalAutorized: 0.0,

      incomesAccumulateds: 0.0,
      incomesAccumulatedsTotal: 0.0,
      incomesSubtotalAutorized: 0.0,

      nameMonth: "",

      ISR: initialoptionIsrSimplified,
    },
    taxISRPlataformsTechnologies: {
      serviceAlienation: {
        ISR: initialOptionIsrPlataform,
        subtotalServiceAlineationClasified: 0.0,
        subtotalServiceLendingClasified: 0.0,
        totalServiceAlienationFinal: 0.0,
        totalServiceLendingFinal: 0.0,
        totalAlienationPlataform: 0.0,
        totalForIntermediaries: 0.0,
        totalForUsers: 0.0,
        totalIsr: 0.0,
        totalLendingPlataform: 0.0,
        totalService: 0.0,
        totalRetained: 0.0,
      },
      serviceGround: {
        ISR: initialOptionIsrPlataform,
        subtotalServiceDealerClasified: 0.0,
        subtotalServicePassengersClasified: 0.0,
        totalIsr: 0.0,
        totalService: 0.0,
        totalServicePassengersFinal: 0.0,
        totalServiceDealerFinal: 0.0,
        totalForIntermediaries: 0.0,
        totalForUsers: 0.0,
        totalDealerPlataform: 0.0,
        totalPassengerPlataform: 0.0,
        totalRetained: 0.0,
      },
      serviceLodging: {
        ISR: initialOptionIsrPlataform,
        subtotalServiceLodgingClasified: 0.0,
        totalServiceLodgingFinal: 0.0,
        totalForIntermediaries: 0.0,
        totalForUsers: 0.0,
        totalIsr: 0.0,
        totalLodgingPlataform: 0.0,
        totalService: 0.0,
        totalRetained: 0.0,
      },
      totalIncomes: 0.0,
      totalForIntermediaries: 0.0,
      totalForUsers: 0.0,
    },
    taxIVAPlataformsTechnologies: {
      ivaCaused: 0.0,
      ivaExpenseTotal: 0.0,
      ivaPeriodsPrevius: 0.0,
      ivaToDeclared: 0.0,
      optionIva: {
        porcentage: 0.16,
      },
      retentionPlataform: 0.0,
      totalIva: 0.0,
    },
    taxISRRIF: {
      calculatedBase: 0.0,
      calculatedBaseTotal: 0.0,
      deductionIsr: 0.0,
      expensesHigherToIncome: 0.0,
      expensesHigherToIncomePrev: 0.0,
      expensesHigherToIncomePrevFinal: 0.0,
      ISR: initialoptionIsr,
      isrDetermined: 0.0,
      isrMarginal: 0.0,
      reductionAmount: 0.0,
      subtotalIncomes: 0.0,
      subtotalExpenseAutorized: 0.0,
      subtotalIncomesAutorized: 0.0,
      totalIsr: 0.0,
      utility: 0.0,
    },
    taxIVARIF: {
      deductionIsr: 0.0,

      ivaReduced: 0.0,

      ivaCharged: 0.0,
      ivaCreditable: 0.0,

      ivaPublicGeneral: 0.0,
      ivaRetained: 0.0,

      ivaToCharge: 0.0,
      IVAMonthsPrev: 0.0,

      totalTax16Expense: 0.0,
      totalTaxforeignExpense: 0.0,

      subtotalExpense0: 0.0,
      subtotalExpense16: 0.0,
      subtotalExpenseForeign: 0.0,
      subtotalIncomes0: 0.0,
      subtotalIncomes16: 0.0,
      subtotalIncomesExento: 0.0,
      subtotalIncomesPublicGeneral: 0.0,
      totalIva: 0.0,
      totalLIVA: 1.0,
    },
    taxISRLease: {
      depresiationFixedAsset: 0.0,
      depresiations: [],
      blindDeduction: 0.0,
      blindPorcentage: 0.35,
      ISR: initialOptionLease,
      isBlindDeduction: true,
      subtotalPredialExpense: 0.0,
      taxableBase: 0.0,
      TotalISRRetained: 0.0,
      totalISR: 0.0,
      subtotalIncomesAutorized: 0.0,
      subtotalExpenseAutorized: 0.0,
    },
    taxIVALease: {
      IVAMonthsPrev: 0.0,
      totalRateIncome16: 0.0,
      totalRateinedIncomeIVA: 0.0,
      totalIvaTraslated: 0.0,
      totalIVAExpense: 0.0,
      subtotalIvaLease: 0.0,
      totalIVA: 0.0,
    },
    taxpayerId: taxpayerId,
    year: year,
    ISRPlataform: {},
  });

  const {
    ISRPlataform,
    taxISRHonorarium,
    taxIVAHonorarium,
    taxISRLease,
    taxIVALease,
    taxISRRIF,
    taxIVARIF,
    taxISRPlataformsTechnologies,
    taxIVAPlataformsTechnologies,
    comment,
    taxISRSimplified,
    taxIVASimplified,
  } = formValues;

  useEffect(() => {
    if (finishPackage) navigationPage(history, taxpayerFinishPackage);
  }, [finishPackage]);

  /* useEffect(() => {

        if(!loadAll && sesionSat && captcha){
         handleModal(<DownloadXmlLoading/>)
        }
        if(loadAll && sesionSat){
          handleModal()
        }

  }, [loadAll,sesionSat])  */

  useEffect(() => {
    if (finishIncomes && finishRetentions && finishExpenses) {
      setTimeout(() => {
        setLoadAll(true);
      }, 3000);
    }
  }, [finishIncomes, finishRetentions, finishExpenses]);

  useEffect(() => {
    if (Object.keys(taxpayerSelected).length === 0 && sesionSat) {
      dispatch(taxpayerSelectedLoading(taxpayerId, regimeSatCode));
      setData(taxpayerSelected);
    }
  }, [dispatch, taxpayerId, regimeSatCode, sesionSat]); // Se elimina variable ' taxpayerSelected,' por que se sicla si no encuentra regsitros apra profileId
  // }, [ dispatch, taxpayerId, taxpayerSelected, sesionSat ]);

  useEffect(() => {
    setInformationToLoaded(false);
    if (month && taxpayerId && year) {
      setInformationToLoaded(true);
    }
  }, [month, setInformationToLoaded, taxpayerId, year]);

  useEffect(() => {
    if (month) {
      setFormValues((prevState) => {
        return {
          ...prevState,
          monthName: obtainMonth(parseInt(month) - 1),
        };
      });
    }
  }, [month, setFormValues]);

  useEffect(() => {
    if (commentJson) {
      setFormValues((prevState) => {
        return {
          ...prevState,
          comments: commentJson,
        };
      });
    }
  }, [commentJson, setFormValues]);

  // }, [dispatch, isrJson, ISRPlataform, ivaJson, month, regimeSatCode, taxpayerId, taxISRHonorarium, taxIVAHonorarium, taxISRLease, taxIVALease, taxISRRIF, taxIVARIF, taxISRPlataformsTechnologies, taxIVAPlataformsTechnologies, year,sesionSat ]);

  useEffect(() => {
    let petition = {
      reportId: id,
    };
    if (Object.keys(isrJson).length > 2 && Object.keys(ivaJson).length > 2) {
      // console.log(isrJson)
      if (regimeSatCode === "625") {
        petition["taxISRPlataformsTechnologies"] = { ...JSON.parse(isrJson) };
        petition["taxIVAPlataformsTechnologies"] = { ...JSON.parse(ivaJson) };
        // petition['Resume'] = {...JSON.parse(resume)}
      }
      if (regimeSatCode === "621") {
        petition["taxISRRIF"] = { ...JSON.parse(isrJson) };
        petition["taxIVARIF"] = { ...JSON.parse(ivaJson) };
      }
      if (regimeSatCode === "606") {
        petition["taxISRLease"] = { ...JSON.parse(isrJson) };
        petition["taxIVALease"] = { ...JSON.parse(ivaJson) };
      }
      if (regimeSatCode === "612") {
        petition["taxISRHonorarium"] = { ...JSON.parse(isrJson) };
        petition["taxIVAHonorarium"] = { ...JSON.parse(ivaJson) };
      }
      if (regimeSatCode === "626") {
        petition["taxISRSimplified"] = { ...JSON.parse(isrJson) };
        petition["taxIVASimplified"] = { ...JSON.parse(ivaJson) };
      }
    }
    setFormValues((prevState) => {
      return {
        ...prevState,
        ...petition,
      };
    });
  }, [id, isrJson, ivaJson, regimeSatCode, setFormValues, authorizations]);

  useEffect(() => {
    if (!periodLoaded && !periodSelected && informationToLoaded && sesionSat) {
      dispatch(
        getRequestByPeriod({ month: month, profileId: taxpayerId, year: year })
      );
      setPeriodLoaded(true);
    }
  }, [
    dispatch,
    informationToLoaded,
    month,
    taxpayerId,
    periodLoaded,
    periodSelected,
    year,
    sesionSat,
  ]);

  useEffect(() => {
    if (informationToLoaded && sesionSat) {
      const date = new Date(year, month, 0);
      let dateDownloaded = {
        paymentAt: moment(date).format("MM-DD-YYYY"),
        profileId: taxpayerId,
        regimeSatCode: regimeSatCode,
      };
      if (incomes.length === 0 && !incomesLoaded) {
        dispatch(incomesStartLoading(dateDownloaded));
        setIncomesLoaded(true);
      }
      if (expenses.length === 0 && !expensesLoaded) {
        dispatch(
          expenseStartLoading(dateDownloaded, refreshComplementPayments)
        );
        setExpensesLoaded(true);
      }
      if (retentions.length === 0 && !retentionsLoaded) {
        dispatch(retentionStartLoading(dateDownloaded));
        setRetentionsLoaded(true);
      }
    }
  }, [
    dispatch,
    expenses,
    expensesLoaded,
    incomes,
    incomesLoaded,
    complements,
    informationToLoaded,
    month,
    regimeSatCode,
    retentions,
    retentionsLoaded,
    taxpayerId,
    year,
    sesionSat,
  ]);

  useEffect(() => {
    if (sesionRetentionSat) {
      const date = new Date(year, month, 0);
      let dateDownloaded = {
        paymentAt: moment(date).format("MM-DD-YYYY"),
        profileId: taxpayerId,
        regimeSatCode: regimeSatCode,
      };
      dispatch(retentionStartLoading(dateDownloaded));
    }
  }, [month, regimeSatCode, taxpayerId, year, sesionRetentionSat]);

  // Refresca la informacion de Complementos de Gastos
  const refreshComplementPayments = (onSuccess = null) => {
    let petition = {
      profileId: taxpayerId,
      satCode: regimeSatCode,
      periodMonth: month,
      periodYear: year,
      commentsJson: {},
    };
    petition.isrJson = JSON.stringify({});
    petition.ivaJson = JSON.stringify({});
    petition.Resume = JSON.stringify({});

    dispatch(preAutorizedReportRegisterStart(petition, onSuccess));
  };

  const handleSubmit = (comment) => {
    let petition = {
      reportId: id,
      comment: {
        whoComment: `Cont. ${userName}`,
        comments: comment,
        dateResponse: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    };
    dispatch(preAutorizedReportUpdateStart(petition, true));
  };

  const activationReportPresenta = () => {
    Swal.fire({
      title: "Motivo",
      text: "Escribe el motivo de apertura",
      input: "textarea",
      confirmButtonText: "Enviar",
    }).then((result) => {
      if (result.value) {
        handleSubmit(result.value);
      }
    });
  };

  useEffect(() => {
    if (
      Object.keys(isrJson).length === 0 &&
      Object.keys(ivaJson).length === 0 &&
      sesionSat
    ) {
      let petition = {
        profileId: taxpayerId,
        satCode: regimeSatCode,
        periodMonth: month,
        periodYear: year,
        commentsJson: {},
      };
      petition.isrJson = JSON.stringify({});
      petition.ivaJson = JSON.stringify({});
      petition.Resume = JSON.stringify({});

      refreshComplementPayments();

      let monthPrev = parseInt(month) - 1;
      let yearPrev = parseInt(year);

      if (regimeSatCode === "621") {
        monthPrev = parseInt(month) - 2;
        if (monthPrev === 0) {
          monthPrev = 12;
          yearPrev = parseInt(year) - 1;
        }
      }

      if (parseInt(month) === 1) {
        monthPrev = 12;
        yearPrev = parseInt(year) - 1;
      }

      petition["periodMonth"] = monthPrev;
      petition["periodYear"] = yearPrev;

      dispatch(preAutorizedReportRegisterMonthPrevStart(petition));
    }
  }, [sesionSat]);

  const descargaXML = () => {
    Swal.fire({
      title:
        "Este proceso descargará todos los XML (Ingresos y gastos) del contribuyente, que estén comprendidos dentro del periodo del reporte.",
      text: `Este proceso podría tardar algún tiempo dependiendo de la cantidad de documentos a descargar. ¿Deseas continuar?`,
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    }).then((result) => {
      setLoading(false);
      if (result.value) {
        setShowComponent(true);
        setLoading(true);
        // Pasar el id del reporte como preReporteId
        // dispatch(downloadSatStartLoading({ month: month, profileId: taxpayerId, year: year, requestType: '1', captcha: 'GNJHKJ' }, handleModal, "Verificando sesión", refreshComplementPayments, id))
        dispatch(downloadSatStartLoadingAsync(id));
      }
    });
  };

  const downloadGeneralPublic = () => {
    dispatch(
      downloadSatStartLoading(
        {
          month: month,
          profileId: taxpayerId,
          year: year,
          requestType: "3",
          captcha: "GNJHKJ",
        },
        handleModal.bind(),
        "Verificando Sesión"
      )
    );
    handleModal(
      <CaptchaForm2
        month={month}
        profileId={taxpayerId}
        year={year}
        requestType="3"
        id="imgRete"
      />
    );
  };

  const downloadRetentions = () => {
    dispatch(
      downloadSatStartLoading(
        {
          month: month,
          profileId: taxpayerId,
          year: year,
          requestType: "2",
          captcha: "GNJHKJ",
        },
        handleModal.bind(),
        "Verificando Sesión"
      )
    );
    handleModal(
      <CaptchaForm2
        month={month}
        profileId={taxpayerId}
        year={year}
        requestType="2"
        id="imgRete"
      />
    );
  };

  const [activeTab, setactiveTab] = useState("");

  const handleTabClick = (tabIde) => {
    setactiveTab(tabIde);
  };

  return (
    <>
      <>
        {showComponent && (
          <div className="alert alert-primary text-center " role="alert">
            <div
              className="text-center"
              data-backdrop="static"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <hr />
              <div className="text-center my-3 mt-3">
                <p className="b-0">OBTENIENDO DATOS DEL SAT</p>
                <p className="bottom-0">Por favor espere un momento</p>
                {loading && <LinearProgress />}{" "}
                {/* Muestra LinearProgress si loading es true */}
              </div>
              <hr />
            </div>
          </div>
        )}
      </>

      {!loadAll && sesionSat && (
        <div className="alert alert-primary text-center " role="alert">
          <div
            className="text-center"
            data-backdrop="static"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <hr />
            <div className="text-center my-3 mt-3">
              <p className="b-0">
                Procesando los calculos del reporte y clasificando
              </p>
              <p className="bottom-0">Por favor espere un momento</p>
              <LinearProgress />
            </div>
            <hr />
          </div>
        </div>
      )}
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    <h4>DETALLE DE RESUMEN ANUAL - {period}</h4>
                  </div>
                  {!isAdmin && (
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                      <Link
                        to={ACCOUNTING(taxpayerId, regimeSatCode, year)}
                        className="btn btn-danger btn-sm float-right"
                      >
                        <i className="fas fa-arrow-left"></i> Regresar
                      </Link>
                    </div>
                  )}
                  {isBoss && status === "Presentada" ? (
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 float-rigth">
                      <button
                        className="btn btn-danger float-right"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="El reporte ha sido presentado, para volver a trabajarlo da clic"
                        onClick={() => activationReportPresenta()}
                      >
                        Habilitar reporte
                      </button>
                    </div>
                  ) : (
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 float-rigth">
                      <div className="float-right bg-secondary">
                        <span className="float-right p-1 text-white">
                          {status}
                        </span>
                      </div>
                      <div className="float-right">
                        <span className="float-right p-1">Estatus</span>
                      </div>
                      <button
                        className="btn btn-danger float-right"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Descarga XML"
                        style={{ marginRight: "4px" }}
                        onClick={() => descargaXML()}
                      >
                        Descarga de XML
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
            <div className="row justify-content-center">
              <div className="col-12 col-md-4 d-flex align-items-stretch">
                <div
                  className="w-100 h-100 bg-white rounded shadow-sm p-2"
                  style={{ minHeight: "100%" }}
                >
                  {formValues.regimeSatCode === "625" && (
                    <PlataformInformation detailsFormValues={formValues} />
                  )}
                  {formValues.regimeSatCode === "606" && (
                    <LeaseInformation detailsFormValues={formValues} />
                  )}
                  {formValues.regimeSatCode === "612" && (
                    <HonorariumInformation detailsFormValues={formValues} />
                  )}
                  {formValues.regimeSatCode === "621" && (
                    <RifInformation detailsFormValues={formValues} />
                  )}
                  {formValues.regimeSatCode === "626" && (
                    <SimplifiedInformation detailsFormValues={formValues} />
                  )}
                </div>
              </div>
              <div className="col-12 col-md-4 d-flex align-items-stretch">
                <div
                  className="w-100 h-100 bg-white rounded shadow-sm p-2"
                  style={{ minHeight: "100%" }}
                >
                  <StatisticsTable preReportId={id} />
                </div>
              </div>
              <div className="col-12 col-md-4 d-flex align-items-stretch">
                <div
                  className="w-100 h-100 bg-white rounded shadow-sm p-2"
                  style={{ minHeight: "100%" }}
                >
                  <TaxpayerInformation
                    regimeSatCode={regimeSatCode}
                    taxpayer={taxpayerSelected}
                    year={year}
                    month={month}
                    isOld={false}
                  />
                </div>
              </div>
            </div>
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <a
                  className="nav-item nav-link active"
                  id="nav-income-tab"
                  data-toggle="tab"
                  href="#nav-income"
                  role="tab"
                  aria-controls="nav-income"
                  aria-selected="true"
                  onClick={() => handleTabClick("nav-income")}
                >
                  Ingresos.
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-complement_income-tab"
                  data-toggle="tab"
                  href="#nav-complement_income"
                  role="tab"
                  aria-controls="nav-complement_income"
                  aria-selected="true"
                  onClick={() => handleTabClick("nav-CompIncome")}
                >
                  Complementos Ingresos.
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-expenses-tab"
                  data-toggle="tab"
                  href="#nav-expenses"
                  role="tab"
                  aria-controls="nav-expenses"
                  aria-selected="true"
                >
                  Gastos
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-complement_expense-tab"
                  data-toggle="tab"
                  href="#nav-complement_expense"
                  role="tab"
                  aria-controls="nav-complement_expense"
                  aria-selected="true"
                >
                  Complementos gastos
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-retention-tab"
                  data-toggle="tab"
                  href="#nav-retention"
                  role="tab"
                  aria-controls="nav-retention"
                  aria-selected="true"
                >
                  Retenciones
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-taxcalculation-tab"
                  data-toggle="tab"
                  href="#nav-taxcalculation"
                  role="tab"
                  aria-controls="nav-taxcalculation"
                  aria-selected="true"
                  onClick={() => handleTabClick("nav-taxCalculation")}
                >
                  Cálculo de impuestos
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-comments-tab"
                  data-toggle="tab"
                  href="#nav-comments"
                  role="tab"
                  aria-controls="nav-comments"
                  aria-selected="true"
                >
                  Comentarios
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-tax-files-tab"
                  data-toggle="tab"
                  href="#nav-tax-files"
                  role="tab"
                  aria-controls="nav-tax-files"
                  aria-selected="true"
                >
                  Archivos fiscales
                </a>
                <a
                  className="nav-item nav-link"
                  id="nav-files-tab"
                  data-toggle="tab"
                  href="#nav-files"
                  role="tab"
                  aria-controls="nav-files"
                  aria-selected="true"
                >
                  Documentos fiscales
                </a>
              </div>
            </nav>
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-income"
                role="tabpanel"
                aria-labelledby="nav-income-tab"
              >
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 float-rigth"></div>
                <Income
                  formValuesDetailsSummary={formValues}
                  setFormValuesDetailsSummary={setFormValues}
                  status={status}
                />
              </div>
              <div
                className="tab-pane fade"
                id="nav-complement_income"
                role="tabpanel"
                aria-labelledby="nav-complement_income-tab"
              >
                <ComplementIncome
                  formValuesDetailsSummary={formValues}
                  setFormValuesDetailsSummary={setFormValues}
                  refreshComplementPayments={refreshComplementPayments}
                  status={status}
                />
              </div>
              <div
                className="tab-pane fade"
                id="nav-expenses"
                role="tabpanel"
                aria-labelledby="nav-expenses-tab"
              >
                <Expenses
                  status={status}
                  formValuesDetailsSummary={formValues}
                  refreshComplementPayments={refreshComplementPayments}
                  setFormValuesDetailsSummary={setFormValues}
                />
              </div>
              <div
                className="tab-pane fade"
                id="nav-complement_expense"
                role="tabpanel"
                aria-labelledby="nav-complement_expense-tab"
              >
                <Complement
                  formValuesDetailsSummary={formValues}
                  setFormValuesDetailsSummary={setFormValues}
                  refreshComplementPayments={refreshComplementPayments}
                  status={status}
                />
              </div>
              <div
                className="tab-pane fade"
                id="nav-retention"
                role="tabpanel"
                aria-labelledby="nav-retention-tab"
              >
                {isBoss && status === "Presentada" ? (
                  <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 float-rigth"></div>
                ) : (
                  <button
                    id="btnDownloadRetentions"
                    className="btn btn-sm btn-primary"
                    onClick={() => downloadRetentions()}
                  >
                    Descargar Retenciones
                  </button>
                )}
                <div></div>
                <Retention
                  formValuesDetailsSummary={formValues}
                  setFormValuesDetailsSummary={setFormValues}
                  isrJson={taxISRPlataformsTechnologies}
                  ivaJson={taxIVAPlataformsTechnologies}
                />
              </div>
              <div
                className="tab-pane fade"
                id="nav-taxcalculation"
                role="tabpanel"
                aria-labelledby="nav-taxcalculation-tab"
              >
                <TaxCalculation
                  formValuesDetailsSummary={formValues}
                  setFormValuesDetailsSummary={setFormValues}
                  status={status}
                  refreshComplementPayments={refreshComplementPayments}
                  activeTab={activeTab}
                  setactiveTab={setactiveTab}
                />
              </div>
              <div
                className="tab-pane fade"
                id="nav-comments"
                role="tabpanel"
                aria-labelledby="nav-comments-tab"
              >
                <CommentsScreen
                  formValuesDetailsSummary={formValues}
                  status={status}
                />
              </div>

              <div
                className="tab-pane fade"
                id="nav-tax-files"
                role="tabpanel"
                aria-labelledby="nav-tax-files-tab"
              >
                <div className="row">
                  <CertificateDetailsScreen
                    isAdmin={true}
                    taxpayerId={taxpayerId}
                  />

                  <EfirmaDetailsScreen isAdmin={true} taxpayerId={taxpayerId} />
                </div>
                <div className="row">
                  <ComplianceOpinionDetailsScreen
                    isAdmin={true}
                    taxpayerId={taxpayerId}
                  />
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="nav-files"
                role="tabpanel"
                aria-labelledby="nav-files-tab"
              >
                <FilesScreen
                  month={month}
                  reportId={id}
                  taxDocuments={taxDocuments}
                  taxpayerId={taxpayerId}
                  year={year}
                  status={status}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
